import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function ContractRequestIcon({ className }: IconProps) {
  return (
    <svg
      width="81"
      height="90"
      viewBox="0 0 81 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M70.7879 89.697V13.3334C70.7879 11.394 69.0909 9.69702 67.1515 9.69702H3.63636C1.69697 9.69702 0 11.1516 0 13.3334V80.0001C0 85.3334 4.36364 89.697 9.69697 89.697H70.7879Z"
        fill="#EAEEF9"
      />
      <path
        d="M9.93945 89.697C14.5455 89.697 18.4243 86.303 19.1516 81.697C19.1516 80.9697 19.8788 80.4849 20.6061 80.4849H78.5455C79.5152 80.4849 80.2425 81.2121 80.0001 82.1818C79.2728 86.5455 75.394 89.697 70.7879 89.697H9.93945Z"
        fill="#00C4B3"
      />
      <path
        d="M38.0602 52.1211C30.3026 52.1211 23.9996 57.9393 23.0299 65.212C22.7874 66.1817 23.7571 67.1514 24.7268 67.1514H51.3935C52.3632 67.1514 53.3329 66.1817 53.0905 65.212C52.1208 57.9393 45.8177 52.1211 38.0602 52.1211Z"
        fill="#00416B"
      />
      <path
        d="M49.6966 44.1212C49.6966 50.6667 44.3632 55.7576 38.0602 55.7576C31.5147 55.7576 26.4238 50.4243 26.4238 44.1212C26.4238 37.5758 31.7572 32.4849 38.0602 32.4849C44.6056 32.4849 49.6966 37.5758 49.6966 44.1212Z"
        fill="#EAEEF9"
      />
      <path
        d="M46.3032 44.1213C46.3032 48.7274 42.6668 52.3638 38.0608 52.3638C33.4547 52.3638 29.8184 48.7274 29.8184 44.1213C29.8184 39.5153 33.4547 35.8789 38.0608 35.8789C42.6668 35.8789 46.3032 39.5153 46.3032 44.1213Z"
        fill="#00416B"
      />
      <path
        d="M68.8485 0L56 3.39394C55.5151 3.39394 55.5151 4.12121 55.7576 4.36364L57.9394 6.54545C58.1818 6.78788 58.1818 7.0303 57.9394 7.27273L45.8182 19.3939C45.5758 19.6364 45.3333 19.6364 45.0909 19.3939L39.7576 14.0606C39.5151 13.8182 39.2727 13.8182 39.0303 14.0606L27.6364 25.4545C27.3939 25.697 27.1515 25.697 26.9091 25.4545L21.3333 20.3636C21.0909 20.1212 20.8485 20.1212 20.6061 20.3636L0 40.7273V49.2121L20.6061 28.8485C20.8485 28.6061 21.0909 28.6061 21.3333 28.8485L26.6667 34.1818C26.9091 34.4242 27.1515 34.4242 27.3939 34.1818L38.7879 22.7879C39.0303 22.5455 39.2727 22.5455 39.5151 22.7879L44.8485 28.1212C45.0909 28.3636 45.3333 28.3636 45.5758 28.1212L62.0606 11.8788C62.303 11.6364 62.5454 11.6364 62.7879 11.8788L64.9697 14.0606C65.2121 14.303 65.697 14.303 65.9394 13.8182L69.3333 1.21212C69.5758 0.242424 69.3333 0 68.8485 0Z"
        fill="#00C4B3"
      />
    </svg>
  );
}
